export const TourInfoData = {
    title: "PewDiePie",
    channelId: "UC-lHJZR3Gqxm24_Vd_AJ5Yw",
    avatar:
        "https://yt3.ggpht.com/a/AGF-l79FVckie4j9WT-4cEW6iu3gPd4GivQf_XNSWg=s240-c-k-c0xffffffff-no-rj-mo",
    country: "US",
    tags: ["SATIRE", "pewdie", "pewds", "pdp", "pewdiepie"],
    topics: [
        { subject: "Entertainment", data: 39 },
        { subject: "Gaming", data: 11 }
    ],
    subscriberCount: 102000000,
    totalViewCount: 24089040194,
    videoCount: 4027,
    avgEngageRate: 8.2,
    subscribersRank: 1,
    monthViewRank: 14,
    monthSubscriberRank: 362,
    monthViewRateRank: 302,
    monthSubscriberRateRank: 231,
    recentAvgViewRank: 134,
    recentAvgEngageRateRank: 182,
    todaySubscriberRank: 43,
    todaySubscriberCount: 0,
    todaySubscriberRate: 0,
    todayViewCount: 9147691,
    todayViewRate: 0,
    monthSubscriberCount: 0,
    monthSubscriberRate: 0,
    monthViewCount: 262332400,
    monthViewRate: 1.1,
    recentAvgViewCount: 4620813,
    recentAvgEngageRate: 8.6,
    recentVideos: [
        {
            title: "I Should Have Listened....",
            videoId: "eJEMzUd3Tns",
            viewCount: 1836598,
            engageRate: 11.4,
            publishAt: "2019-12-01",
            cover: "https://i.ytimg.com/vi/eJEMzUd3Tns/mqdefault.jpg"
        },
        {
            title: "I take on the STRONGEST Mob in Minecraft",
            videoId: "ZzjGNTd76Jg",
            viewCount: 3008298,
            engageRate: 7.3,
            publishAt: "2019-11-30",
            cover: "https://i.ytimg.com/vi/ZzjGNTd76Jg/mqdefault.jpg"
        },
        {
            title: "I summoned a forbidden Minecraft Boss",
            videoId: "yB4Q3ezW9fM",
            viewCount: 3921090,
            engageRate: 7.8,
            publishAt: "2019-11-29",
            cover: "https://i.ytimg.com/vi/yB4Q3ezW9fM/mqdefault.jpg"
        },
        {
            title: "I LOVE this Game!!",
            videoId: "os_r9wAb8Cc",
            viewCount: 4945184,
            engageRate: 7.6,
            publishAt: "2019-11-28",
            cover: "https://i.ytimg.com/vi/os_r9wAb8Cc/mqdefault.jpg"
        },
        {
            title: "Stock Images needs to be Stopped!",
            videoId: "uiTyxzMu20s",
            viewCount: 3765654,
            engageRate: 7.4,
            publishAt: "2019-11-27",
            cover: "https://i.ytimg.com/vi/uiTyxzMu20s/mqdefault.jpg"
        },
        {
            title:
                "Terraria - Part 1- The most REQUESTED game Ive EVER GOTTEN!",
            videoId: "zLfYD2OOtsc",
            viewCount: 6232826,
            engageRate: 10.4,
            publishAt: "2019-11-26",
            cover: "https://i.ytimg.com/vi/zLfYD2OOtsc/mqdefault.jpg"
        },
        {
            title: "Stop finding my old SCHOOL PHOTOS!!",
            videoId: "aiU3q0ZAuBs",
            viewCount: 6098666,
            engageRate: 7.6,
            publishAt: "2019-11-25",
            cover: "https://i.ytimg.com/vi/aiU3q0ZAuBs/mqdefault.jpg"
        },
        {
            title: "You Laugh you DRINK",
            videoId: "XOMWzg_NveE",
            viewCount: 4483410,
            engageRate: 7.8,
            publishAt: "2019-11-24",
            cover: "https://i.ytimg.com/vi/XOMWzg_NveE/mqdefault.jpg"
        },
        {
            title: "The Joker VS Society meme",
            videoId: "SKMWsn_6AJQ",
            viewCount: 3842970,
            engageRate: 9.8,
            publishAt: "2019-11-23",
            cover: "https://i.ytimg.com/vi/SKMWsn_6AJQ/mqdefault.jpg"
        },
        {
            title: "I joined a Photoshop Competition (NOT GOOD)",
            videoId: "ClqRIMpClWM",
            viewCount: 4649325,
            engageRate: 9.1,
            publishAt: "2019-11-22",
            cover: "https://i.ytimg.com/vi/ClqRIMpClWM/mqdefault.jpg"
        },
        {
            title: "I'm SUEING this Meme for identity Theft!",
            videoId: "zJkBlkrrEVw",
            viewCount: 4169584,
            engageRate: 8.2,
            publishAt: "2019-11-21",
            cover: "https://i.ytimg.com/vi/zJkBlkrrEVw/mqdefault.jpg"
        },
        {
            title: "Morgz is CANCELLED.",
            videoId: "icdDPuiNwGE",
            viewCount: 5675776,
            engageRate: 10.8,
            publishAt: "2019-11-20",
            cover: "https://i.ytimg.com/vi/icdDPuiNwGE/mqdefault.jpg"
        },
        {
            title: "My comment section is the worst on YouTube",
            videoId: "cOeLz87i0XE",
            viewCount: 5541950,
            engageRate: 9.5,
            publishAt: "2019-11-18",
            cover: "https://i.ytimg.com/vi/cOeLz87i0XE/mqdefault.jpg"
        },
        {
            title: "I Built A Cake Ladder in Minecraft to prove god is real",
            videoId: "xejFV2JCmSM",
            viewCount: 4843523,
            engageRate: 9,
            publishAt: "2019-11-19",
            cover: "https://i.ytimg.com/vi/xejFV2JCmSM/mqdefault.jpg"
        },
        {
            title: "I DESTROY people at MY OWN Game",
            videoId: "VA6SK6gcGn8",
            viewCount: 3320081,
            engageRate: 6.7,
            publishAt: "2019-11-17",
            cover: "https://i.ytimg.com/vi/VA6SK6gcGn8/mqdefault.jpg"
        },
        {
            title: "I made a GIANT Robot Dog for My Minecraft Dog",
            videoId: "G5JBZk-DiQU",
            viewCount: 3455994,
            engageRate: 8.1,
            publishAt: "2019-11-16",
            cover: "https://i.ytimg.com/vi/G5JBZk-DiQU/mqdefault.jpg"
        },
        {
            title: "Zoomer thinks his Mom is too IRRELEVANT to speak to",
            videoId: "YnPs3rsOnNc",
            viewCount: 6758948,
            engageRate: 7.4,
            publishAt: "2019-11-15",
            cover: "https://i.ytimg.com/vi/YnPs3rsOnNc/mqdefault.jpg"
        },
        {
            title: "Sonic looks EPIC now!",
            videoId: "qHo3kQ-FV5w",
            viewCount: 5661215,
            engageRate: 9,
            publishAt: "2019-11-14",
            cover: "https://i.ytimg.com/vi/qHo3kQ-FV5w/mqdefault.jpg"
        },
        {
            title:
                "????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????????hm",
            videoId: "3CvMALbPoYE",
            viewCount: 5396149,
            engageRate: 8.5,
            publishAt: "2019-11-13",
            cover: "https://i.ytimg.com/vi/3CvMALbPoYE/mqdefault.jpg"
        },
        {
            title: "I build a Giant Flying Meatball in Minecraft",
            videoId: "JqvdAuuXVyA",
            viewCount: 4809027,
            engageRate: 8,
            publishAt: "2019-11-12",
            cover: "https://i.ytimg.com/vi/JqvdAuuXVyA/mqdefault.jpg"
        }
    ],
    twoMonthAvgViewCount: 5370524,
    twoMonthAvgEngageRate: 7.9,
    subscribersRankPercentage: 1,
    monthViewRankPercentage: 1,
    monthSubscriberRankPercentage: 89.9,
    monthViewRateRankPercentage: 70.3,
    monthSubscriberRateRankPercentage: 93.2,
    recentAvgViewRankPercentage: 2.1,
    recentAvgEngageRateRankPercentage: 68,
    todaySubscriberRankPercentage: 87.8,
    pk: 1086,
    twoMonthVideos: [
        {
            title: "I Should Have Listened....",
            videoId: "eJEMzUd3Tns",
            viewCount: 1836467,
            engageRate: 11.4,
            cover: "https://i.ytimg.com/vi/eJEMzUd3Tns/mqdefault.jpg",
            publishAt: "2019-12-01"
        },
        {
            title: "I take on the STRONGEST Mob in Minecraft",
            videoId: "ZzjGNTd76Jg",
            viewCount: 3008257,
            engageRate: 7.3,
            cover: "https://i.ytimg.com/vi/ZzjGNTd76Jg/mqdefault.jpg",
            publishAt: "2019-11-30"
        },
        {
            title: "I summoned a forbidden Minecraft Boss",
            videoId: "yB4Q3ezW9fM",
            viewCount: 3919370,
            engageRate: 7.8,
            cover: "https://i.ytimg.com/vi/yB4Q3ezW9fM/mqdefault.jpg",
            publishAt: "2019-11-29"
        },
        {
            title: "I LOVE this Game!!",
            videoId: "os_r9wAb8Cc",
            viewCount: 4943093,
            engageRate: 7.6,
            cover: "https://i.ytimg.com/vi/os_r9wAb8Cc/mqdefault.jpg",
            publishAt: "2019-11-28"
        },
        {
            title: "Stock Images needs to be Stopped!",
            videoId: "uiTyxzMu20s",
            viewCount: 3765652,
            engageRate: 7.4,
            cover: "https://i.ytimg.com/vi/uiTyxzMu20s/mqdefault.jpg",
            publishAt: "2019-11-27"
        },
        {
            title:
                "Terraria - Part 1- The most REQUESTED game Ive EVER GOTTEN!",
            videoId: "zLfYD2OOtsc",
            viewCount: 6232819,
            engageRate: 10.4,
            cover: "https://i.ytimg.com/vi/zLfYD2OOtsc/mqdefault.jpg",
            publishAt: "2019-11-26"
        },
        {
            title: "Stop finding my old SCHOOL PHOTOS!!",
            videoId: "aiU3q0ZAuBs",
            viewCount: 6098176,
            engageRate: 7.5,
            cover: "https://i.ytimg.com/vi/aiU3q0ZAuBs/mqdefault.jpg",
            publishAt: "2019-11-25"
        },
        {
            title: "You Laugh you DRINK",
            videoId: "XOMWzg_NveE",
            viewCount: 4483284,
            engageRate: 7.8,
            cover: "https://i.ytimg.com/vi/XOMWzg_NveE/mqdefault.jpg",
            publishAt: "2019-11-24"
        },
        {
            title: "The Joker VS Society meme",
            videoId: "SKMWsn_6AJQ",
            viewCount: 3842777,
            engageRate: 9.8,
            cover: "https://i.ytimg.com/vi/SKMWsn_6AJQ/mqdefault.jpg",
            publishAt: "2019-11-23"
        },
        {
            title: "I joined a Photoshop Competition (NOT GOOD)",
            videoId: "ClqRIMpClWM",
            viewCount: 4649323,
            engageRate: 9.1,
            cover: "https://i.ytimg.com/vi/ClqRIMpClWM/mqdefault.jpg",
            publishAt: "2019-11-22"
        },
        {
            title: "I'm SUEING this Meme for identity Theft!",
            videoId: "zJkBlkrrEVw",
            viewCount: 4169413,
            engageRate: 8.2,
            cover: "https://i.ytimg.com/vi/zJkBlkrrEVw/mqdefault.jpg",
            publishAt: "2019-11-21"
        },
        {
            title: "Morgz is CANCELLED.",
            videoId: "icdDPuiNwGE",
            viewCount: 5675512,
            engageRate: 10.8,
            cover: "https://i.ytimg.com/vi/icdDPuiNwGE/mqdefault.jpg",
            publishAt: "2019-11-20"
        },
        {
            title: "I Built A Cake Ladder in Minecraft to prove god is real",
            videoId: "xejFV2JCmSM",
            viewCount: 4843444,
            engageRate: 9.1,
            cover: "https://i.ytimg.com/vi/xejFV2JCmSM/mqdefault.jpg",
            publishAt: "2019-11-19"
        },
        {
            title: "My comment section is the worst on YouTube",
            videoId: "cOeLz87i0XE",
            viewCount: 5541787,
            engageRate: 9.6,
            cover: "https://i.ytimg.com/vi/cOeLz87i0XE/mqdefault.jpg",
            publishAt: "2019-11-18"
        },
        {
            title: "I DESTROY people at MY OWN Game",
            videoId: "VA6SK6gcGn8",
            viewCount: 3320047,
            engageRate: 6.7,
            cover: "https://i.ytimg.com/vi/VA6SK6gcGn8/mqdefault.jpg",
            publishAt: "2019-11-17"
        },
        {
            title: "I made a GIANT Robot Dog for My Minecraft Dog",
            videoId: "G5JBZk-DiQU",
            viewCount: 3455994,
            engageRate: 8.1,
            cover: "https://i.ytimg.com/vi/G5JBZk-DiQU/mqdefault.jpg",
            publishAt: "2019-11-16"
        },
        {
            title: "Zoomer thinks his Mom is too IRRELEVANT to speak to",
            videoId: "YnPs3rsOnNc",
            viewCount: 6758926,
            engageRate: 7.4,
            cover: "https://i.ytimg.com/vi/YnPs3rsOnNc/mqdefault.jpg",
            publishAt: "2019-11-15"
        },
        {
            title: "Sonic looks EPIC now!",
            videoId: "qHo3kQ-FV5w",
            viewCount: 5661194,
            engageRate: 9,
            cover: "https://i.ytimg.com/vi/qHo3kQ-FV5w/mqdefault.jpg",
            publishAt: "2019-11-14"
        },
        {
            title:
                "????????????????????????????????????????????????????????????????????????????????????????????????????",
            videoId: "3CvMALbPoYE",
            viewCount: 5396149,
            engageRate: 8.5,
            cover: "https://i.ytimg.com/vi/3CvMALbPoYE/mqdefault.jpg",
            publishAt: "2019-11-13"
        },
        {
            title: "I build a Giant Flying Meatball in Minecraft",
            videoId: "JqvdAuuXVyA",
            viewCount: 4809027,
            engageRate: 8,
            cover: "https://i.ytimg.com/vi/JqvdAuuXVyA/mqdefault.jpg",
            publishAt: "2019-11-12"
        },
        {
            title: "Which YouTubers Could I Beat in a Fight??",
            videoId: "bnkDBfV3OoM",
            viewCount: 4191552,
            engageRate: 6.5,
            cover: "https://i.ytimg.com/vi/bnkDBfV3OoM/mqdefault.jpg",
            publishAt: "2019-11-11"
        },
        {
            title: "STOP calling me A BOOMER!!!",
            videoId: "J3BltOoCFbU",
            viewCount: 5323377,
            engageRate: 9.3,
            cover: "https://i.ytimg.com/vi/J3BltOoCFbU/mqdefault.jpg",
            publishAt: "2019-11-10"
        },
        {
            title: "(CHALLENGE) You Lose You Laugh, Can you do it?",
            videoId: "ZFyqoXZHbvc",
            viewCount: 5227684,
            engageRate: 6.8,
            cover: "https://i.ytimg.com/vi/ZFyqoXZHbvc/mqdefault.jpg",
            publishAt: "2019-11-09"
        },
        {
            title: "Minecraft mobs I could beat in a fight????????",
            videoId: "mOwX1ZNY2Jc",
            viewCount: 4496661,
            engageRate: 7.1,
            cover: "https://i.ytimg.com/vi/mOwX1ZNY2Jc/mqdefault.jpg",
            publishAt: "2019-11-08"
        },
        {
            title: "The BROFIST is declared a HATE SYMBOL! (this is bad)",
            videoId: "F5QWUOAcg_Q",
            viewCount: 5386458,
            engageRate: 11.4,
            cover: "https://i.ytimg.com/vi/F5QWUOAcg_Q/mqdefault.jpg",
            publishAt: "2019-11-07"
        },
        {
            title: "Blursed images is HILARIOUS",
            videoId: "UrJVL3CftIU",
            viewCount: 4543527,
            engageRate: 7.1,
            cover: "https://i.ytimg.com/vi/UrJVL3CftIU/mqdefault.jpg",
            publishAt: "2019-11-06"
        },
        {
            title: "I plant 20 000 000 Trees in Minecraft (Not Creative)",
            videoId: "hT0uqXlZ70A",
            viewCount: 9243720,
            engageRate: 5.8,
            cover: "https://i.ytimg.com/vi/hT0uqXlZ70A/mqdefault.jpg",
            publishAt: "2019-11-05"
        },
        {
            title: '"Ok Boomer" - The ultimate Insult',
            videoId: "AAUiyQyEARs",
            viewCount: 6000696,
            engageRate: 7,
            cover: "https://i.ytimg.com/vi/AAUiyQyEARs/mqdefault.jpg",
            publishAt: "2019-11-04"
        },
        {
            title: "THEY ACTUALLY DID THAT?! (mad)",
            videoId: "LlW7Es7gStA",
            viewCount: 5518504,
            engageRate: 8.3,
            cover: "https://i.ytimg.com/vi/LlW7Es7gStA/mqdefault.jpg",
            publishAt: "2019-11-03"
        },
        {
            title: "We went to Canada for something EPIC!",
            videoId: "ar25iJORncI",
            viewCount: 4548892,
            engageRate: 9.3,
            cover: "https://i.ytimg.com/vi/ar25iJORncI/mqdefault.jpg",
            publishAt: "2019-11-02"
        },
        {
            title: "Kids are dumb.",
            videoId: "UK15xIMc1DY",
            viewCount: 6768988,
            engageRate: 7.4,
            cover: "https://i.ytimg.com/vi/UK15xIMc1DY/mqdefault.jpg",
            publishAt: "2019-11-01"
        },
        {
            title: "Rare Insults is a Treassure!",
            videoId: "wnvaqGuiLlI",
            viewCount: 6576746,
            engageRate: 8.4,
            cover: "https://i.ytimg.com/vi/wnvaqGuiLlI/mqdefault.jpg",
            publishAt: "2019-10-31"
        },
        {
            title: "We need to STOP INSTAGRAM Filters!",
            videoId: "SsHGYhWpXZM",
            viewCount: 3551902,
            engageRate: 8.5,
            cover: "https://i.ytimg.com/vi/SsHGYhWpXZM/mqdefault.jpg",
            publishAt: "2019-10-30"
        },
        {
            title: "Am I a Boomer?",
            videoId: "feYE_0-Ts_w",
            viewCount: 4484489,
            engageRate: 8.7,
            cover: "https://i.ytimg.com/vi/feYE_0-Ts_w/mqdefault.jpg",
            publishAt: "2019-10-29"
        },
        {
            title: "You Cringe, You Cringe Challenge (Cringe)",
            videoId: "ZcFmJ_sce68",
            viewCount: 5196936,
            engageRate: 7.7,
            cover: "https://i.ytimg.com/vi/ZcFmJ_sce68/mqdefault.jpg",
            publishAt: "2019-10-28"
        },
        {
            title: "Which is my worst CONTROVERSY?",
            videoId: "Ce11NMlBOTo",
            viewCount: 4151022,
            engageRate: 13.3,
            cover: "https://i.ytimg.com/vi/Ce11NMlBOTo/mqdefault.jpg",
            publishAt: "2019-10-27"
        },
        {
            title: "Try not to MIND BLOWN challenge!",
            videoId: "ZQG91KPBNTk",
            viewCount: 6540459,
            engageRate: 6.4,
            cover: "https://i.ytimg.com/vi/ZQG91KPBNTk/mqdefault.jpg",
            publishAt: "2019-10-26"
        },
        {
            title: "This has to end..",
            videoId: "RzwcYXGQz9w",
            viewCount: 6502496,
            engageRate: 6.3,
            cover: "https://i.ytimg.com/vi/RzwcYXGQz9w/mqdefault.jpg",
            publishAt: "2019-10-25"
        },
        {
            title: "VIBE CHECK VIBE CHECK VIBE CHECK VIBE CHECK VIBE CHECK",
            videoId: "mYugwGNOIeM",
            viewCount: 4593548,
            engageRate: 7.5,
            cover: "https://i.ytimg.com/vi/mYugwGNOIeM/mqdefault.jpg",
            publishAt: "2019-10-24"
        },
        {
            title: "Mine All Day (Minecraft Music Video)",
            videoId: "UAlIq7BKNxg",
            viewCount: 16596577,
            engageRate: 10.7,
            cover: "https://i.ytimg.com/vi/UAlIq7BKNxg/mqdefault.jpg",
            publishAt: "2019-10-23"
        },
        {
            title: "The New MINECRAFT BLOCK is AMAZING!",
            videoId: "ZAA-BWvG_0o",
            viewCount: 7166230,
            engageRate: 6.1,
            cover: "https://i.ytimg.com/vi/ZAA-BWvG_0o/mqdefault.jpg",
            publishAt: "2019-10-22"
        },
        {
            title: "THANKS I HATE IT",
            videoId: "D3UebgcVsIM",
            viewCount: 5485270,
            engageRate: 11.9,
            cover: "https://i.ytimg.com/vi/D3UebgcVsIM/mqdefault.jpg",
            publishAt: "2019-10-21"
        },
        {
            title: "You Haha, You Lose!",
            videoId: "UNu5A1wGJQc",
            viewCount: 6592475,
            engageRate: 6.9,
            cover: "https://i.ytimg.com/vi/UNu5A1wGJQc/mqdefault.jpg",
            publishAt: "2019-10-20"
        },
        {
            title: "Pewdiepie Is BANNED in China",
            videoId: "8HehfOtRbUk",
            viewCount: 7372464,
            engageRate: 8,
            cover: "https://i.ytimg.com/vi/8HehfOtRbUk/mqdefault.jpg",
            publishAt: "2019-10-19"
        },
        {
            title: "I Give Life Advice to Strangers on Yahoo Answers.. (good)",
            videoId: "3_mt33jWpjE",
            viewCount: 4926318,
            engageRate: 7,
            cover: "https://i.ytimg.com/vi/3_mt33jWpjE/mqdefault.jpg",
            publishAt: "2019-10-18"
        },
        {
            title:
                "This video is Mildly Infuriating.. /r/mildlyinfuriating #47 [REDDIT REVIEW]",
            videoId: "E0asAgpHvaI",
            viewCount: 5391252,
            engageRate: 6.5,
            cover: "https://i.ytimg.com/vi/E0asAgpHvaI/mqdefault.jpg",
            publishAt: "2019-10-17"
        },
        {
            title:
                "Hong Kong vs Joker Ends Fortnite  [MEME REVIEW] ???? ????#68",
            videoId: "OhWZavn2OvM",
            viewCount: 4717638,
            engageRate: 7.6,
            cover: "https://i.ytimg.com/vi/OhWZavn2OvM/mqdefault.jpg",
            publishAt: "2019-10-16"
        },
        {
            title: "This needs to stop.. LWIAY #0095",
            videoId: "SRhueFPsCeY",
            viewCount: 5514839,
            engageRate: 7.8,
            cover: "https://i.ytimg.com/vi/SRhueFPsCeY/mqdefault.jpg",
            publishAt: "2019-10-15"
        },
        {
            title: "Nah. - RL Minecraft - 2",
            videoId: "2K4_dNwyc5o",
            viewCount: 5541905,
            engageRate: 5.5,
            cover: "https://i.ytimg.com/vi/2K4_dNwyc5o/mqdefault.jpg",
            publishAt: "2019-10-14"
        },
        {
            title:
                "How to make a Minecraft Creeper NEVER EXPLODE again. (Tutorial) Minecraft - Part 35",
            videoId: "HKNj9CSzKxA",
            viewCount: 5911743,
            engageRate: 6.7,
            cover: "https://i.ytimg.com/vi/HKNj9CSzKxA/mqdefault.jpg",
            publishAt: "2019-10-13"
        },
        {
            title: "The WEIRDEST Camping Game EVER - The Forest VR",
            videoId: "RwrgU4cnEvY",
            viewCount: 3306932,
            engageRate: 5.8,
            cover: "https://i.ytimg.com/vi/RwrgU4cnEvY/mqdefault.jpg",
            publishAt: "2019-10-12"
        },
        {
            title: "I met a Minecraft Girlfriend - RL Minecraft - 1",
            videoId: "QKlUTCtY0Zs",
            viewCount: 5377204,
            engageRate: 6.6,
            cover: "https://i.ytimg.com/vi/QKlUTCtY0Zs/mqdefault.jpg",
            publishAt: "2019-10-11"
        },
        {
            title: "Top 10 FORBIDDEN items /r/itemshop #46 [REDDIT REVIEW]",
            videoId: "cY9kbO4GY_s",
            viewCount: 5705362,
            engageRate: 5.7,
            cover: "https://i.ytimg.com/vi/cY9kbO4GY_s/mqdefault.jpg",
            publishAt: "2019-10-10"
        },
        {
            title:
                "MAD respect if you do this.. /r/MADLADS #45 [REDDIT REVIEW]",
            videoId: "MyurD6wWgEk",
            viewCount: 5052380,
            engageRate: 7.6,
            cover: "https://i.ytimg.com/vi/MyurD6wWgEk/mqdefault.jpg",
            publishAt: "2019-10-09"
        },
        {
            title: "NEVER ask who JOE is! [MEME REVIEW] ???? ????#67",
            videoId: "wH533kbXm2c",
            viewCount: 5146309,
            engageRate: 7.8,
            cover: "https://i.ytimg.com/vi/wH533kbXm2c/mqdefault.jpg",
            publishAt: "2019-10-08"
        },
        {
            title: "stop the reddit drama LWIAY #0094",
            videoId: "nUfb4UxnvJk",
            viewCount: 5529460,
            engageRate: 7.6,
            cover: "https://i.ytimg.com/vi/nUfb4UxnvJk/mqdefault.jpg",
            publishAt: "2019-10-07"
        },
        {
            title: "Rip Ohio /r/softwaregore #48 [REDDIT REVIEW]",
            videoId: "uN-TvWzeEvA",
            viewCount: 6973065,
            engageRate: 7.1,
            cover: "https://i.ytimg.com/vi/uN-TvWzeEvA/mqdefault.jpg",
            publishAt: "2019-10-06"
        },
        {
            title: "I play a forbidden Amnesia mod",
            videoId: "XbwE6pk2Ze0",
            viewCount: 3254340,
            engageRate: 7.1,
            cover: "https://i.ytimg.com/vi/XbwE6pk2Ze0/mqdefault.jpg",
            publishAt: "2019-10-05"
        },
        {
            title: "Minecraft New Thanos update is CRAZY",
            videoId: "usnzZJPOnJw",
            viewCount: 5720691,
            engageRate: 4.5,
            cover: "https://i.ytimg.com/vi/usnzZJPOnJw/mqdefault.jpg",
            publishAt: "2019-10-04"
        },
        {
            title:
                "There was an attempt to... /r/therewasanattempt /r/therewasanattempt #44 [REDDIT REVIEW]",
            videoId: "VHiAvH1QLQA",
            viewCount: 5690650,
            engageRate: 6.8,
            cover: "https://i.ytimg.com/vi/VHiAvH1QLQA/mqdefault.jpg",
            publishAt: "2019-10-03"
        }
    ],
    recentViewHighest: {
        title: "Zoomer thinks his Mom is too IRRELEVANT to speak to",
        videoId: "YnPs3rsOnNc",
        viewCount: 6758948,
        engageRate: 7.4,
        publishAt: "2019-11-15",
        cover: "https://i.ytimg.com/vi/YnPs3rsOnNc/mqdefault.jpg"
    },
    recentViewLowest: {
        title: "I Should Have Listened....",
        videoId: "eJEMzUd3Tns",
        viewCount: 1836598,
        engageRate: 11.4,
        publishAt: "2019-12-01",
        cover: "https://i.ytimg.com/vi/eJEMzUd3Tns/mqdefault.jpg"
    },
    recentEngageRateHighest: {
        title: "I Should Have Listened....",
        videoId: "eJEMzUd3Tns",
        viewCount: 1836598,
        engageRate: 11.4,
        publishAt: "2019-12-01",
        cover: "https://i.ytimg.com/vi/eJEMzUd3Tns/mqdefault.jpg"
    },
    recentEngageRateLowest: {
        title: "I DESTROY people at MY OWN Game",
        videoId: "VA6SK6gcGn8",
        viewCount: 3320081,
        engageRate: 6.7,
        publishAt: "2019-11-17",
        cover: "https://i.ytimg.com/vi/VA6SK6gcGn8/mqdefault.jpg"
    },
    twoMonthViewHighest: {
        title: "Mine All Day (Minecraft Music Video)",
        videoId: "UAlIq7BKNxg",
        viewCount: 16596577,
        engageRate: 10.7,
        cover: "https://i.ytimg.com/vi/UAlIq7BKNxg/mqdefault.jpg",
        publishAt: "2019-10-23"
    },
    twoMonthViewLowest: {
        title: "I Should Have Listened....",
        videoId: "eJEMzUd3Tns",
        viewCount: 1836467,
        engageRate: 11.4,
        cover: "https://i.ytimg.com/vi/eJEMzUd3Tns/mqdefault.jpg",
        publishAt: "2019-12-01"
    },
    twoMonthEngageRateHighest: {
        title: "Which is my worst CONTROVERSY?",
        videoId: "Ce11NMlBOTo",
        viewCount: 4151022,
        engageRate: 13.3,
        cover: "https://i.ytimg.com/vi/Ce11NMlBOTo/mqdefault.jpg",
        publishAt: "2019-10-27"
    },
    twoMonthEngageRateLowest: {
        title: "Minecraft New Thanos update is CRAZY",
        videoId: "usnzZJPOnJw",
        viewCount: 5720691,
        engageRate: 4.5,
        cover: "https://i.ytimg.com/vi/usnzZJPOnJw/mqdefault.jpg",
        publishAt: "2019-10-04"
    },
    weeklyPublishedVideos: 7
};
export const TourInfoProposalItems = [
    {
        id: 556,
        title: "My Project",
        channels: [],
        isEdit: false,
        isDelete: null,
        show: true,
        isTitleEdit: false,
        isThisCreatorInItem: false,
        editedTitle: "My Project"
    },
];



// WEBPACK FOOTER //
// ./src/Info/dev/TourInfoData.js